import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterPageComponent } from './components/master-page/master-page.component';
import { StepTabsComponent } from './components/step-tabs/step-tabs.component';
import { SetHeadersInterceptor } from './set-headers.httpinterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SideNavComponent } from './components/side-nav/side-nav.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    MasterPageComponent,
    StepTabsComponent,
    SideNavComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    MasterPageComponent,
    StepTabsComponent,
    SideNavComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetHeadersInterceptor,
      multi: true,
    }
  ]
})
export class CoreModule { }
